export const dictionary = {
  TITLE: {
    ES: "Pasos para crear tu tienda",
    EN: "Steps to create your store",
  },

  STEP1: {
    ES: "Completa los datos de tu cuenta.",
    EN: "Complete your account details.",
  },
  STEP2: {
    ES: "Establece tus categorías.",
    EN: "Upload your categories.",
  },
  STEP3: {
    ES: "Carga tus productos con al menos una categoría.",
    EN: "Upload your products with at least one category.",
  },
  COMPLETED_STEPS: {
    ES: "¡Felicitaciones!",
    EN: "Congrats!",
  },
  COMPLETED_STEPS2: {
    ES: "Tu tienda está disponible.",
    EN: "Your store is now available.",
  },
  SHARE_STORE: {
    ES: "Compartir tienda",
    EN: "Share store",
  },
} as const;
